import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { StockOverviewComponent } from 'src/app/cabinet/stock-overview/stock-overview.component';

const routes: Routes = [
   {
      path: '',
      component: StockOverviewComponent,
      pathMatch: 'full',
   },
];

@NgModule({
   imports: [RouterModule.forChild(routes)],
   exports: [RouterModule],
})
export class StockOverviewRoutingModule {}
